import React, { useState } from "react";
import styles from "./Table.module.sass";
import cn from "classnames";
import Row from "./Row";
import { Formik, Form, Field } from "formik";
import TextInput from "../../../components/TextInput";
import { get_products_by_name, get_one_product } from "../../../API/Product";
import { message } from "antd";
const Table = ({ items, setSelectedProducts, setVisibleModal }) => {
  const [searchedProducts, setSearchedProducts] = useState([]);
  const [selectedVariants, setSelectedVariants] = useState({});
  const [searchInitialValue, setSearchInitialValue] = useState({
    productSearchString: "",
  });
  const handleProductSearch = async (productSearchString) => {
    try {
      if (productSearchString && productSearchString !== "") {
        const response = await get_products_by_name(productSearchString);
        const product = response.data;

        // setSelectedVariants((prevProducts) => {
        //   return prevProducts
        //     .map((p) =>
        //       p.id === product.id
        //         ? { ...p, barcodeQuantity: (p.barcodeQuantity || 1) + 1 } // Increment barcodeQuantity
        //         : p
        //     )
        //     .concat(
        //       prevProducts.some((p) => p.id === product.id)
        //         ? []
        //         : [{ ...product, barcodeQuantity: 1 }]
        //     ); // Add new product with barcodeQuantity 1 if not found
        // });
      }
    } catch (error) {
      message.error("Failed to fetch Products");
    }
  };

  const handleProductCheck = (productId, variants) => {
    const isChecked =
      (selectedVariants[productId]?.length || 0) !== variants.length;
    setSelectedVariants({
      ...selectedVariants,
      [productId]: isChecked ? variants.map((v) => v.id) : [],
    });
  };

  const handleVariantCheck = (productId, variantId) => {
    const selected = selectedVariants[productId] || [];
    const newSelected = selected.includes(variantId)
      ? selected.filter((id) => id !== variantId)
      : [...selected, variantId];

    setSelectedVariants({
      ...selectedVariants,
      [productId]: newSelected,
    });
  };

  const addProducts = () => {
    const selected = items.flatMap((product) =>
      (selectedVariants[product.id] || []).map((variantId) =>
        product.ProductVariants.find((variant) => variant.id === variantId)
      )
    );

    setSelectedProducts(selected);
    setVisibleModal(false);
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.table}>
        <div className={styles.row}></div>
        {items.map((product) => {
          const variants = product.ProductVariants || [];
          const selectedCount = selectedVariants[product.id]?.length || 0;

          const isAllSelected =
            variants.length > 0 &&
            variants.every((variant) =>
              selectedVariants[product.id]?.includes(variant.id)
            );

          const isPartiallySelected =
            selectedCount > 0 && selectedCount < variants.length;

          return (
            <Row
              key={product.id}
              product={product}
              variants={variants}
              isAllSelected={isAllSelected}
              isPartiallySelected={isPartiallySelected}
              onProductCheck={() => handleProductCheck(product.id, variants)}
              onVariantCheck={(variantId) =>
                handleVariantCheck(product.id, variantId)
              }
              selectedVariants={selectedVariants[product.id] || []}
            />
          );
        })}
      </div>
      <div className={cn("panel", styles.panel)}>
        <div className={styles.btns}>
          <button className={cn("button-stroke", styles.button)}>Cancel</button>
          <button className={cn("button", styles.button)} onClick={addProducts}>
            Add
          </button>
        </div>
      </div>
    </div>
  );
};

export default Table;
